import _Message from './Message';

import './style/index.js';

export * from './type';

export const Message = _Message;

export default Message;
